module.exports = __webpack_public_path__ + "img/envelope-open-text.4e2a6764.svg";